import { ContactMinDtoWithRelationsDto, PartyRelationshipTypeCode } from 'types/contacts';

const employsAnyOf = (contact: ContactMinDtoWithRelationsDto, personIds: Set<number>): boolean =>
    (contact.relations ?? []).some(
        ({ partyRelationshipTypeCode, otherParty }) =>
            partyRelationshipTypeCode === PartyRelationshipTypeCode.EMPLOYEE && personIds.has(otherParty.id)
    );

export function getMissingEmployersOfPersons(
    contacts: ContactMinDtoWithRelationsDto[],
    personIds: number[],
    currentCompanies: { id: number }[]
): ContactMinDtoWithRelationsDto[] {
    const selectedPersonIds = new Set(personIds);
    const currentCompanyIds = new Set(currentCompanies.map(({ id }) => id));
    return contacts.filter((contact) => !currentCompanyIds.has(contact.id) && employsAnyOf(contact, selectedPersonIds));
}
